import React, { useEffect, useState } from 'react';
import TopMenuSlider from '../../Templates/CategoryProductList/TopMenuSlider';
import useStore from '../../../store/useStore';
import { multipleAndCheck } from '../../../Utils/WindowUtils';
import _get from 'lodash/get';

const MenuTopSlider: React.FC = () => {
  const { categories, headerHeightCal } = useStore();
  const menuHeader = document.querySelector('.carousel');
  const [menuSlider, setMenuSlider] = useState(0);
  const deliveryFeeDescription = document.querySelector('.deliveryText__deliveryFeeDescription');
  useEffect(() => {
    if (multipleAndCheck(headerHeightCal && menuHeader)) {
      const sliderHeight = _get(menuHeader, ['offsetHeight'], 0);
      const deliveryHeight = _get(deliveryFeeDescription, ['offsetHeight'], 0);
      const headerVal = headerHeightCal?.replace('px', '');
      const result = parseInt(headerVal) + sliderHeight + deliveryHeight;
      setMenuSlider(result);
    }
  }, [headerHeightCal, menuHeader, deliveryFeeDescription]);

  return (
    <div className="menu-top-slider" style={{ marginBottom: menuSlider + 'px' }}>
      <TopMenuSlider categories={categories} />
    </div>
  );
};

export default MenuTopSlider;
